import styles from './TreeItem.module.css';

import ArrowImg from 'assets/svg/arrow-01.svg';

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spiner from '../../../ui/Spiner';
import { address_server_short, PUBLIC_ASSETS } from '../../../config';
import Icon from '../../../ui/Icon';
import { observer } from 'mobx-react-lite';

const TreeItem = observer(
  ({
    item,
    isExpanded,
    isLoading,
    hasChildren,
    onToggle,
    onClick,
    renderItem,
    nodeLabelField = 'name',
    defaultIcon,
    actionButtons = null,
    dragHandleProps = null,
    isDragging = false,
    paddingLeft = 0,
    isActive,
  }) => {
    const handleToggleClick = (e) => {
      e.stopPropagation();
      if (hasChildren) {
        onToggle();
      }
    };

    const getItemLabel = () => {
      return item[nodeLabelField] || item.label || 'Элемент';
    };

    const icon = () => {
      if (item.icon) return <Icon src={address_server_short + PUBLIC_ASSETS + item.icon} />;
      if (defaultIcon) return defaultIcon(item);
      return null;
    };

    if (renderItem) {
      return renderItem({
        item,
        isExpanded,
        isLoading,
        hasChildren,
        onToggle,
        labelText: getItemLabel(),
        dragHandleProps,
        isDragging,
      });
    }

    return (
      <div
        className={classNames(styles.content, {
          [styles.isDragging]: isDragging,
          [styles.isActive]: isActive,
        })}
        role="button"
        tabIndex={0}
        onClick={onClick}
        style={{
          paddingLeft: `${paddingLeft}px`,
        }}
        aria-expanded={hasChildren ? isExpanded : undefined}
      >
        <div
          className={classNames(styles.toggle, {
            [styles.toggleExpanded]: isExpanded,
          })}
          onClick={handleToggleClick}
          style={{
            visibility: hasChildren ? 'visible' : 'hidden',
            cursor: hasChildren ? 'pointer' : 'default',
          }}
        >
          {hasChildren ? (
            isLoading ? (
              <Spiner customSize={'0.5rem'} />
            ) : (
              <Icon src={ArrowImg} className={styles.arrowImg} />
            )
          ) : (
            <div
              style={{
                width: '14px',
                height: '14px',
              }}
            ></div>
          )}
        </div>

        <div
          className={styles.label}
          title={getItemLabel()}
          {...dragHandleProps}
          style={{
            ...(item.color ? { color: item.color } : {}),
          }}
        >
          <div> {icon()}</div>

          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {getItemLabel()}
          </div>
          <div
            className={classNames(styles.actionButtons, {
              [styles.visible]: isActive,
            })}
            onClick={(e) => e.stopPropagation()}
          >
            {actionButtons?.(item)}
          </div>
        </div>
      </div>
    );
  },
);

TreeItem.propTypes = {
  item: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool,
  isLoading: PropTypes.bool,
  hasChildren: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  renderItem: PropTypes.func,
  nodeLabelField: PropTypes.string,
  defaultIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actionButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  dragHandleProps: PropTypes.object,
  isDragging: PropTypes.bool,
};

export default memo(TreeItem);
